import * as React from 'react';
import { connect } from 'react-redux';
import { withNavigation } from '../General/withNavigation';
import { toast } from '../../utilities/appToast';
import { setTiposPublicacion, resetSetTiposPublicaciones } from '../../actions/tiposPublicacionActions';
import Auth from '../../auth';
import ClickOutsideHandler from '../General/ClickOutsideHandler';
import GoBackArrow from '../General/GoBackArrow';
import Tab from '../General/Tab';
import MiniSpinner from '../General/MiniSpinner';
import DatosBasicos from './DatosBasicos';
import DatosContactos from './DatosContactos';
import Publicacion from './Publicacion';
import Moderador from './Moderador';
import MailUsuario from './MailUsuario';
import Liquidacion from './Liquidacion';
import { postTiposPublicacionAsociarSeller } from '../../api/axios';
import { fetchSeller, editSeller, setFiltroSeller, postSeller } from '../../actions/sellersActions';
import { editando, setObject, limpiarFiltros } from '../../actions/generalActios';
import { isEmail } from '../../utilities/formatString';
import PropTypes from 'prop-types';
import { resolveTipoPublicacionId } from '../../helper/tipoPublicacionHelper';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

const getErroresApi = (error) => {
    const data = error?.response?.data;

    if (Array.isArray(data?.errores)) return data.errores.filter(Boolean);
    if (data?.errors && typeof data.errors === 'object') {
        return Object.values(data.errors).flat().filter(Boolean);
    }

    return [];
};

function toastErroresApi(errs) {
    if (!Array.isArray(errs) || !errs.length) return false;
    errs.forEach((e) => {
        if (e && typeof e === 'object' && ('item1' in e || 'item2' in e)) {
            const msg = [e.item1, e.item2, e.item3, e.item4].filter(Boolean).join(' — ');
            if (msg) toast.error(msg);
        } else if (typeof e === 'string') toast.error(e);
        else if (e != null) toast.error(String(e));
    });
    return true;
}

class SellerNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: this.props.location?.state ?? 0,
            showSpinner: false
        };
    }

    /** Metadatos de pestañas; el JSX de cada panel se arma en render para que siempre reciba props actuales y no queden instancias “congeladas” al cambiar de pestaña. */
    getTabDefinitions = () => [
        { name: "Datos Básicos ", icon: "ti-id-badge" },
        { name: "Datos de contactos", icon: "ti-headphone-alt" },
        { name: "Publicación", icon: "mdi mdi-tag" },
        { name: "Moderador", icon: "ti-shield" },
        { name: "Usuario", icon: "mdi mdi-email-outline" },
        { name: "Liquidacion", icon: "mdi mdi-chart-bar" },
    ];

    renderActiveTabContent = () => {
        const { history, navigate, location, tipoUsuario } = this.props;
        const i = this.state.activeTab;
        switch (i) {
            case 0:
                return <DatosBasicos key="seller-new-tab-0" />;
            case 1:
                return <DatosContactos key="seller-new-tab-1" />;
            case 2:
                return <Publicacion key="seller-new-tab-2" history={history} />;
            case 3:
                return (
                    <Moderador
                        key="seller-new-tab-3"
                        tipoUsuario={tipoUsuario}
                        history={history}
                        navigate={navigate}
                        location={location}
                        changeTab={this.onChangeActiveTab}
                    />
                );
            case 4:
                return <MailUsuario key="seller-new-tab-4" />;
            case 5:
                return <Liquidacion key="seller-new-tab-5" tipoUsuario={tipoUsuario} />;
            default:
                return null;
        }
    };

    componentDidMount() {
        const { location } = this.props;

        if (location.pathname !== "/Sellers/Nuevo/Select") {
            this.props.setObject({});
        }
        this.props.editando(false);
        // Tras elegir tipos de publicación se navega a /Sellers/Nuevo/Select con setObject(seller).
        // fetchSeller() sin id reemplaza sellers.seller por el template vacío y el merge con generalObject
        // dejaba los campos en blanco (el template pisa al snapshot).
        if (location.pathname !== "/Sellers/Nuevo/Select") {
            this.props.fetchSeller();
        }
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    /** Se usa al abandonar el alta (Volver/Cancelar), no al navegar entre las sub-pantallas del propio wizard. */
    salirDelAlta = (destino = "/Sellers") => {
        this.props.resetSetTiposPublicaciones();
        this.props.navigate(destino);
    }

    asignarTipoPublicacion = async (idSeller) => {
        try {
            const { settedTiposPublicacion } = this.props;
            const tiposArr = Array.isArray(settedTiposPublicacion) ? settedTiposPublicacion : [];
            const idUsuario = Number.parseInt(this.props.userId, 10) || 0;
            const idSellerNum = Number.parseInt(idSeller, 10) || 0;
            const listaIdsTipoPublicacion = tiposArr
                .map((tipo) => resolveTipoPublicacionId(tipo))
                .filter((id) => id != null && Number.isFinite(id) && id > 0);

            if (idUsuario <= 0 || idSellerNum <= 0 || listaIdsTipoPublicacion.length === 0) {
                return;
            }

            const request = {
                idUsuario,
                idSeller: idSellerNum,
                listaIdsTipoPublicacion,
            };

            await postTiposPublicacionAsociarSeller(request);
            toast.success("Tipo de publicación asociado");
        } catch {
            toast.warn("Tipo de publicación no asociado");
        }
    }

    onSubmit = async (event) => {
        event.preventDefault();

        const { userType } = this.props;
        if (userType.isAdminMod || userType.isCategory) {

            let seller = this.props.seller;

            if (seller.password !== seller.confirmarPassword) {
                toast.warn("Las contraseñas no coinciden, verifique");
                return;
            }

            if (!isEmail(seller.email)) {
                toast.warn("e-Mail contacto comercial incorrecto");
                return;
            }

            if (!isEmail(seller.emailUsuario)) {
                toast.warn("e-Mail de usuario incorrecto");
                return;
            }

            const trim = (v) => (v == null ? '' : String(v).trim());
            const pwd = trim(seller.password);
            if (!pwd || pwd.length < 6) {
                toast.warn("La contraseña debe tener al menos 6 caracteres");
                return;
            }
            if (!trim(seller.razonSocial)) {
                toast.warn("Completá la razón social");
                return;
            }
            if (!trim(seller.nombreTienda)) {
                toast.warn("Completá el nombre de tienda");
                return;
            }
            if (!trim(seller.nombreUsuario)) {
                toast.warn("Completá el nombre de usuario");
                return;
            }
            const suf = trim(seller.sufijo);
            if (!suf) {
                toast.warn("Completá el sufijo SKU (Moderador)");
                return;
            }
            const cuitDigits = trim(seller.cuit).replace(/\D/g, '');
            if (cuitDigits.length !== 11) {
                toast.warn("CUIT inválido: deben ser 11 dígitos");
                return;
            }

            this.setState({ showSpinner: true });

            const sellerModificado = {
                ...seller,
                modalidadEPK: "s",
            };

            let sellers = postSeller(sellerModificado);

            sellers.then(res => {
                if (res?.errores?.length) {
                    toastErroresApi(res.errores);
                    return;
                }
                this.asignarTipoPublicacion(res.idSeller).catch(() => {
                    toast.warn("Tipo de publicación no asociado");
                });
                toast.success("Seller agregado con éxito");
                //this.agregarCDNAlSeller(res.idSeller);
                this.afterSellerCreated();
            }).catch(err => {
                const errores = getErroresApi(err);
                if (toastErroresApi(errores)) return;
                toast.error("El seller no pudo ser creado");
            }).finally(() => {
                this.setState({ showSpinner: false });
            });
        }
    }

    redirectToSellers = () => {
        this.props.navigate("/Sellers");
    }

    afterSellerCreated = () => {
        try {
            this.props.resetSetTiposPublicaciones();
            this.props.limpiarFiltros({ ...this.props.emptyFilters, sellers: true });
            this.props.setFiltroSeller({
                razonSocial: "",
                cantidadPagina: 10,
                numeroPagina: 1,
                showFilter: false
            });
            this.redirectToSellers();
        } catch (e) {
            console.error("Error en afterSellerCreated", e);
        }
    }

    render() {
        const { userType } = this.props;
        const canCreateSeller = userType.isAdminMod || userType.isCategory;
        const tabDefs = this.getTabDefinitions();

        return (
            <div className="container py-2">
                <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                    <div className="admin-grupo-busqueda-header">
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <GoBackArrow onBack={() => this.salirDelAlta("/Sellers")} />
                            <div>
                                <h4 className="mb-0 text-body fw-semibold">Crear Seller</h4>
                                <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                                    Completá los datos y la configuración correspondiente del seller.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="px-4 pb-4 pt-2">
                        <ul className="nav nav-tabs customtab seller-new-tabs">
                            {
                                tabDefs.map((tab, index) => {
                                    return <button style={{ border: "none", background: "none" }} key={index} onClick={() => { this.onChangeActiveTab(index) }}>
                                        <Tab
                                            name={tab.name}
                                            icon={tab.icon}
                                            isActive={index === this.state.activeTab}
                                        />
                                    </button>
                                }
                                )
                            }
                        </ul>

                        <form className="form-material" onSubmit={this.onSubmit}>
                            <div className="tab-content">

                                {this.renderActiveTabContent()}

                                <div className="row mt-2">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-center flex-wrap gap-2 align-items-center pt-3 border-top">
                                            <div className="col-12 col-sm-auto text-center" hidden={!this.state.showSpinner}>
                                                <MiniSpinner />
                                            </div>

                                            {canCreateSeller && (
                                                <button
                                                    type="submit"
                                                    disabled={this.state.showSpinner}
                                                    className="btn btn-sm background-rojo-megatone px-4"
                                                >
                                                    Crear Seller
                                                </button>
                                            )}

                                            <button
                                                type="button"
                                                onClick={() => this.salirDelAlta("/Sellers")}
                                                className="btn btn-sm btn-light"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                        </div>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }
}
SellerNew.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.number,
        pathname: PropTypes.string,
    }),
    navigate: PropTypes.func,
    // Redux props
    history: PropTypes.object,
    tipoUsuario: PropTypes.number,
    settedTiposPublicacion: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
        codigo: PropTypes.string,
    })), PropTypes.object]),
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isCategory: PropTypes.bool,
    }),
    userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    seller: PropTypes.shape({
        password: PropTypes.string,
        confirmarPassword: PropTypes.string,
        email: PropTypes.string,
        emailUsuario: PropTypes.string,
        idEmpresaEnviopack: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        codigoPostal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        numeroDomicilio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        diasPlazoPago: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        diasCorte: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    // Actions props
    setObject: PropTypes.func,
    fetchSeller: PropTypes.func,
    editando: PropTypes.func,
}

const mapStateToProps = (state) => ({
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    settedSellerObject: state.general.generalObject,
    emptyFilters: state.general.limpiar,
    seller: selectSellerMerged(state),
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    userType: state.general.userType,
    userId: state.general.userId,
});

const mapDispatchToProps = {
    fetchSeller,
    editSeller,
    editando,
    setTiposPublicacion,
    setObject,
    limpiarFiltros,
    setFiltroSeller,
    createSeller: (seller) => ({ type: 'CREATE_SELLER', payload: seller }),
    resetSetTiposPublicaciones,
};

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(SellerNew));